import { render, staticRenderFns } from "./TurnoManage.vue?vue&type=template&id=6ceeb534&scoped=true"
import script from "./TurnoManage.vue?vue&type=script&lang=js"
export * from "./TurnoManage.vue?vue&type=script&lang=js"
import style0 from "./TurnoManage.vue?vue&type=style&index=0&id=6ceeb534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceeb534",
  null
  
)

export default component.exports